export type FeedbackRatingType = 'emoji' | 'stars' | 'nps';

export type FeedbackTrigger =
  | 'video_end'
  | 'percent_75'
  | 'percent_90'
  | 'custom_time'
  | 'pause'
  | 'exit_intent';

export type FeedbackIdentification = 'none' | 'name' | 'name_email' | 'name_email_whatsapp' | 'use_lead';

export type FeedbackStyle = 'glass-dark' | 'light' | 'minimal';
export type FeedbackPosition = 'center' | 'bottom-center' | 'bottom-right';
export type FeedbackSize = 'compact' | 'default' | 'large';
export type FeedbackAfterSubmitBehavior = 'auto-close' | 'thanks' | 'keep-open';

export interface VideoFeedback {
  enabled: boolean;
  ratingType: FeedbackRatingType;
  trigger: FeedbackTrigger;
  customTimeSec: number; // when trigger === 'custom_time'

  title: string;
  subtitle: string;
  buttonText: string;
  thanksMessage: string;

  comment: {
    enabled: boolean;
    placeholder: string;
    required: boolean;
  };

  identification: FeedbackIdentification;

  appearance: {
    style: FeedbackStyle;
    color: string;
    position: FeedbackPosition;
    size: FeedbackSize;
  };

  afterSubmit: {
    behavior: FeedbackAfterSubmitBehavior;
    autoCloseSec: 2 | 3 | 5 | 0; // 0 = não fechar
  };

  allowRepeatAfter24h: boolean;
}

export const defaultVideoFeedback: VideoFeedback = {
  enabled: false,
  ratingType: 'emoji',
  trigger: 'video_end',
  customTimeSec: 0,

  title: 'Como você avalia este conteúdo?',
  subtitle: 'Sua resposta ajuda a melhorar a experiência.',
  buttonText: 'Enviar feedback',
  thanksMessage: 'Obrigado pelo seu feedback!',

  comment: {
    enabled: false,
    placeholder: 'Conte um pouco sobre sua experiência',
    required: false,
  },

  identification: 'none',

  appearance: {
    style: 'glass-dark',
    color: '#2563FF',
    position: 'center',
    size: 'compact',
  },

  afterSubmit: {
    behavior: 'thanks',
    autoCloseSec: 3,
  },

  allowRepeatAfter24h: false,
};
